/*
 * File: PageHeader.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 6:12:30 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Col, Row, Spin } from 'antd';
import { UserDropdown } from 'components/molecules/UserDropdown';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setSelectedMenu, setStagedTable } from 'redux/poReceipts/po-receipts-slice';
import { useGetApplicationQuery } from 'redux/services/freddyCadabby/freddyCadabbyApi';
import { ReduxState } from 'redux/store';
import Logo from '../../common/assets/logo.svg';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const styles: InlineStylesModel = {
  appName: {
    cursor: 'pointer',
    fontSize: isMobileOnly ? '0.75rem' : '24px',
    marginLeft: isMobileOnly ? '8px' : '16px',
    marginRight: isMobileOnly ? '8px' : '16px',
    color: '#84859a'
  },
  mainContainer: {
    color: 'white'
  },
  link: {
    color: '#84859a'
  },
  userMenu: {
    paddingTop: 7
  },
  wrapper: {
    maxWidth: '1920px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '0 50px'
  }
};

export const PageHeader = (): JSX.Element => {
  const { user, applicationLoading, error } = useSelector((state: ReduxState) => state.app);
  const { data: applicationData } = useGetApplicationQuery(process.env.REACT_APP_APPLICATION_ID);
  const { selectedMenu, stagedTable } = useSelector((state: ReduxState) => state.poReceipts);
  const dispatch = useDispatch();

  const resetMenuTab = (): void => {
    if (selectedMenu !== 'Main') dispatch(setSelectedMenu('Main'));
    if (stagedTable.length) dispatch(setStagedTable(null));
  };

  const applicationNameJSX = applicationLoading ? (
    <Spin />
  ) : (
    <Link onClick={resetMenuTab} to="/" style={styles.link}>
      {error?.actionType?.includes('asyncFetchApplication') ? error?.message : applicationData?.name}
    </Link>
  );

  return (
    <Row style={styles.wrapper} justify="space-between">
      <Col>
        <Row style={styles.mainContainer} align="middle">
          <Col>
            <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL}>
              <Row>
                <img src={Logo} alt="logo" width={'64px'} />
              </Row>
            </a>
          </Col>
          <Col>
            <div style={styles.appName}>
              <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL} style={styles.link}>
                Acuity
              </a>{' '}
              | {applicationNameJSX}
            </div>
          </Col>
        </Row>
      </Col>
      <Col>
        <Col>
          <div style={styles.userMenu}>
            {user?.name.toLocaleUpperCase() ?? 'Unable to load Username'}
            <UserDropdown />
          </div>
        </Col>
      </Col>
    </Row>
  );
};
